import i18n from '@/i18n/index';
const {
  t
} = i18n.global;
export const ChannelStatus = [{
  label: '有效',
  value: 'valid'
}, {
  label: '无效',
  value: 'invalid'
}]; // 运行状态

export const OperatingStatus = [{
  label: '运行',
  value: 1
}, {
  label: '停运',
  value: 0
}]; // 运行状态

export const OperatingStatusNew = [{
  label: '运行',
  value: 'enable'
}, {
  label: '停运',
  value: 'disable'
}]; // 子品牌状态

export const StatusOptions = [{
  label: '待执行',
  value: 'waiting'
}, {
  label: '执行中',
  value: 'running'
}, {
  label: '已结束',
  value: 'end'
}]; // 编码标准

export const ProgramTypeObject = [{
  label: 'H.264',
  value: 0
}, {
  label: 'H.265',
  value: 1
}, {
  label: 'H264,H.265',
  value: '1,0'
}, {
  label: 'H264,H.265',
  value: '0,1'
}];
export const EncodingTypeOptions = [{
  label: 'H.264',
  value: 0
}, {
  label: 'H.265',
  value: 1
}]; // 选择运营模块

export const OperatingModulesObject = [{
  label: '直播频道分类',
  value: 0
}, {
  label: '点播频道分类',
  value: 1
}, {
  label: '点播推荐运营',
  value: 2
}]; // 上级分类

export const ParentsCategory = [{
  label: '根节点',
  value: 'root'
}]; // 影片类型

export const FilmType = [// 原本的value 2:单片 || 1：剧集 || 11：系列片
{
  label: '单片',
  value: 'movie'
}, {
  label: '剧集',
  value: 'tv_series'
}, {
  label: '系列片',
  value: 'video_series'
}]; // 成人内容

export const playLevelObj = [{
  label: '否',
  value: 0
}, {
  label: '是',
  value: 18
}]; // 传输协议

export const transferProtocolObj = [{
  value: 0,
  label: 'HLS'
}, {
  value: 1,
  label: 'DASH'
}, {
  value: 2,
  label: 'P2P'
}, {
  value: 3,
  label: 'HTTP'
}, {
  value: 4,
  label: 'DASH+PDASH'
}]; // 分辨率

export const broadcastTypeObj = [{
  value: 0,
  label: '480P'
}, {
  value: 1,
  label: '720P'
}, {
  value: 2,
  label: '1080P'
}]; // 激活/冻结

export const activeOrFrezz = [{
  value: 0,
  label: '激活'
}, {
  value: 1,
  label: '冻结'
}]; // 视频是否加密

export const videoEncryptionObj = [{
  value: 1,
  label: '是'
}, {
  value: 0,
  label: '否'
}]; // 运营状态

export const OperationStateObj = [{
  value: '',
  label: '全部'
}, {
  value: 0,
  label: '待执行'
}, {
  value: 1,
  label: '执行中'
}, {
  value: 2,
  label: '结束'
}]; // 运营状态

export const OperationStateObjNew = [{
  value: '',
  label: '全部'
}, {
  value: 'waiting',
  label: '待执行'
}, {
  value: 'runnning',
  label: '执行中'
}, {
  value: 'end',
  label: '结束'
}]; // 上线状态

export const RELEASE_STATUS = {
  0: t('未上线'),
  1: t('已上线'),
  2: t('已下线')
};
export const RELEASE_STATUS_NEW = {
  not_online: t('未上线'),
  online: t('已上线'),
  offline: t('已下线'),
  return: t('退回审核')
}; // 上线状态字体颜色

export const RELEASE_COLOR = {
  0: '#F2994A',
  1: '#29B87D',
  2: '#F92D2D'
}; // 上线状态字体颜色

export const RELEASE_COLOR_NEW = {
  not_online: '#F2994A',
  online: '#29B87D',
  offline: '#F92D2D'
}; // 审核状态

export const AUDIT_STATUS = {
  1: t('已审核'),
  2: t('未审核'),
  3: t('未通过'),
  4: t('终端审核'),
  5: t('退回审核')
}; // 审核状态

export const AUDIT_STATUS_NEW = {
  audited: t('已审核'),
  unaudited: t('未审核'),
  not_approved: t('未通过'),
  terminal_audit: t('终端审核'),
  return: t('退回审核'),
  not_crawled: t('待爬取'),
  crawled_error: t('爬取异常')
}; // 审核状态字体颜色

export const AUDIT_COLOR = {
  1: '#29B87D',
  2: '',
  3: '#F92D2D',
  4: '#547BDE',
  5: '#B4B4B4'
}; // 审核状态字体颜色

export const AUDIT_COLOR_NEW = {
  audited: '#29B87D',
  unaudited: '',
  not_approved: '#F92D2D',
  terminal_audit: '#547BDE',
  return: '#B4B4B4',
  crawled_error: '#F45F0E',
  not_crawled: ''
}; // 剧集播放链接审核状态

export const PLAY_AUDIT_STATUS = {
  1: t('已审核'),
  2: t('未审核'),
  3: t('审核中'),
  4: t('未通过')
}; // 剧集播放链接审核状态

export const PLAY_AUDIT_STATUS_NEW = {
  audited: t('已审核'),
  unaudited: t('未审核'),
  auditing: t('审核中'),
  not_approved: t('未通过')
}; // 剧集播放链接审核状态字体颜色

export const PLAY_AUDIT_COLOR = {
  1: '#29B87D',
  2: '',
  3: '#FF9308',
  4: '#F92D2D'
}; // 剧集播放链接审核状态字体颜色

export const PLAY_AUDIT_COLOR_NEW = {
  audited: '#29B87D',
  unaudited: '',
  not_approved: '#FF9308',
  terminal_audit: '#F92D2D'
}; // 付费形式

export const PAY_TYPE = {
  1: 'VIP内容',
  2: '付费单片',
  3: '免费内容'
};
export const paymentFormList = [{
  label: t('VIP内容'),
  value: 1
}, {
  label: t('付费单片'),
  value: 2
}, {
  label: t('免费内容'),
  value: 3
}]; // 服务期

export const Cycle = [{
  label: `1 ${t('个月')}`,
  value: 1
}, {
  label: `2 ${t('个月')}`,
  value: 2
}, {
  label: `3 ${t('个月')}`,
  value: 3
}, {
  label: `6 ${t('个月')}`,
  value: 6
}, {
  label: `12 ${t('个月')}`,
  value: 12
}, {
  label: `24 ${t('个月')}`,
  value: 24
}]; // S3存储管理地区下拉列表

export const S3areaLists = [{
  label: t('US East (Ohio)'),
  value: 'us-east-2'
}, {
  label: t('US East (N. Virginia)'),
  value: 'us-east-1'
}, {
  label: t('US West (Oregon)'),
  value: 'us-west-2'
}, {
  label: t('South America (São Paulo)'),
  value: 'sa-east-1'
}, {
  label: t('Asia Pacific (Mumbai)'),
  value: 'ap-south-1'
}, {
  label: t('Asia Pacific (Seoul)'),
  value: 'ap-northeast-2'
}, {
  label: t('Asia Pacific (Singapore)'),
  value: 'ap-southeast-1'
}, {
  label: t('Asia Pacific (Sydney)'),
  value: 'ap-southeast-2'
}, {
  label: t('Asia Pacific (Tokyo)'),
  value: 'ap-northeast-1'
}, {
  label: t('Canada (Central)'),
  value: 'ca-central-1'
}, {
  label: t('China (Beijing) Region'),
  value: 'cn-north-1'
}, {
  label: t('China (Ningxia)'),
  value: 'cn-northwest-1'
}, {
  label: t('Europe (Frankfurt)'),
  value: 'eu-central-1'
}, {
  label: t('Europe (Ireland)'),
  value: 'eu-west-1'
}, {
  label: t('Europe (London)'),
  value: 'eu-west-2'
}, {
  label: t('Europe (Milan)'),
  value: 'eu-south-1'
}, {
  label: t('Europe (Paris)'),
  value: 'eu-west-3'
} // { label: t('AWS GovCloud (US)'), value: 'us-gov-west-1' },
]; //是否为默认IPTV

export const DefaultOptionsList = [{
  label: t('是'),
  value: 1
}, {
  label: t('否'),
  value: 0
}]; //IPTV加密方式

export const IptvEncryptionList = [{
  label: 'NONE',
  value: 0
}, {
  label: 'TAG_HASH',
  value: 1
}, {
  label: 'JSON_XOR',
  value: 2
}, {
  label: 'DATA_AES',
  value: 3
}]; //iptv请求类型

export const RequestTypeList = [{
  label: 'GET',
  value: 0
}, {
  label: 'POST',
  value: 1
}]; //iptv缓存选项

export const cacheOptions = ref([{
  label: 'Default',
  value: 0
}, {
  label: 'Low',
  value: 1
}, {
  label: 'High',
  value: 2
}]); //iptv ui风格

export const uiStyleOptions = ref([{
  label: 'style 1',
  value: 0
}, {
  label: 'style 2',
  value: 1
}, {
  label: 'style 3',
  value: 2
}]); //账号类型

export const accountTypeOptions = [{
  value: 1,
  label: 'SN'
}, {
  value: 2,
  label: t('账号')
}, {
  value: 3,
  label: t('激活码')
}]; // 测试配置类型

export const testTypeOptions = [{
  label: t('用户名'),
  value: 0
}, {
  label: t('IP范围'),
  value: 1
}, {
  label: t('域名'),
  value: 2
}];
export const serverTypeOptions = ref([{
  label: 'CCCam',
  value: 0
}, {
  label: 'NewCS/MgCamd/Gscam',
  value: 1
}]); //账号类型

export const userTypeObj = {
  1: 'SN',
  2: t('账号'),
  3: t('激活码')
}; // 主题类型

export const themeTypeOptions = [{
  label: t('动态主题'),
  value: 'dynamic'
}, {
  label: t('静态主题'),
  value: 'static'
}]; // 信息源类型

export const sourceIdOptions = [{
  value: 'tmdb',
  label: 'TMDB'
}, {
  value: 'imdb',
  label: 'IMDB'
}, {
  value: 'arab',
  label: 'ARAB'
}]; // 动态主题tableFirstPage组件配置项

export const fieldVisibilityMap = {
  // templateCode 值: [需要显示的字段数组]
  // 盒端stb
  'stb_d_h_r1r6_recommended': ['itemCount', 'imageType'],
  //双行分类+推荐模板
  'stb_d_h_r6r6_recommend': ['itemCount', 'categoryCount', 'type', 'titleOn'],
  'stb_left_side_property': [],
  // 盒端的单行横版模板和单行竖版模板
  'stb_s_c_r6': ['itemCount', 'imageType', 'type', 'titleOn'],
  'stb_s_h_r2': ['itemCount', 'imageType', 'type', 'titleOn'],
  'stb_s_h_r3': ['itemCount', 'imageType', 'type', 'titleOn'],
  'stb_s_h_r4': ['itemCount', 'imageType', 'type', 'titleOn'],
  'stb_s_v_r2': ['itemCount', 'imageType', 'type', 'titleOn'],
  'stb_s_v_r3': ['itemCount', 'imageType', 'type', 'titleOn'],
  'stb_s_v_r4': ['itemCount', 'imageType', 'type', 'titleOn'],
  'stb_s_v_r6': ['itemCount', 'imageType', 'type', 'titleOn'],
  // 双行模板
  'stb_d_h_r3r4': ['imageType', 'type', 'titleOn'],
  'stb_d_h_r2r3': ['imageType', 'type', 'titleOn'],
  'stb_d_h_r3r3': ['imageType', 'type', 'titleOn'],
  'stb_d_h_r4r4': ['imageType', 'type', 'titleOn'],
  'stb_d_h_r2r4': ['imageType', 'type', 'titleOn'],
  'stb_d_h_r6r6': ['imageType', 'type', 'titleOn'],
  //单行分类模板
  'stb_s_h_r6_category': ['categoryCount'],
  //双行固定数量分类6+6
  'stb_d_h_r6r6_category': [],
  // 盒端静态
  'stb_fix1': [],
  'stb_fix2': [],
  'stb_fix3': [],
  'stb_fix4': [],
  'stb_fix5': [],
  'stb_fix6': [],
  'stb_fix7': [],
  // phone
  'phone_s_h_r1_recommend': ['itemCount', 'imageType'],
  'phone_d_v_r3r3': ['imageType', 'type', 'titleOn'],
  'phone_s_h_r2': ['itemCount', 'imageType', 'type', 'titleOn'],
  'phone_s_v_r3': ['itemCount', 'imageType', 'type', 'titleOn'],
  'phone_m_v_r3rn': [],
  // 历史记录
  'phone_history': [],
  // 默认
  'default': [] // 添加更多 templateCode 对应的显示规则

}; // 小标题

export const smallTitleOptions = ref([{
  label: t('开'),
  value: 1
}, {
  label: t('关'),
  value: 0
}]); // 推荐位图

export const imageTypeOptions = ref([{
  label: t('横版'),
  value: 'horizontal'
}, {
  label: t('竖版'),
  value: 'vertical'
}]); // 模块类型

export const typeOptions = ref([{
  label: t('影片'),
  value: 'video'
}, {
  label: t('分类'),
  value: 'category'
}, {
  label: t('分类+更多'),
  value: 'category_more'
}]); // netfly 频道类型

export const channelTypeOptions = ref([{
  label: t('全部'),
  value: ''
}, {
  label: t('影片'),
  value: '2'
}, {
  label: t('剧集'),
  value: '3'
}]); // NETFLY 颗粒度时间类型

export const granularityTimeTypeOptions = ref([{
  label: t('5分钟'),
  value: '5min'
}, {
  label: t('15分钟'),
  value: '15min'
}, {
  label: t('30分钟'),
  value: '30min'
}, {
  label: t('1小时'),
  value: '1h'
}]); // 日期预设选项

export const netflyPresetOptions = [{
  value: 'all',
  label: t('全部')
}, {
  value: 'yesterday',
  label: t('昨天')
}, {
  value: '7',
  label: t('过去7天')
}, {
  value: '30',
  label: t('过去30天')
}, {
  value: '90',
  label: t('过去90天')
}];
export const paidOptions = [{
  label: t('免费节目'),
  value: 0
}, {
  label: t('VIP1: 非VIP限制分辨率'),
  value: 1
}, {
  label: t('VIP2: 非VIP禁止观看'),
  value: 2
}];
export const childModeOptions = [{
  label: t('常规模式'),
  value: 0
}, {
  label: t('儿童模式'),
  value: 1
}];